module.exports = __webpack_public_path__ + "430e11d6e9bad6abb460ace8d0450c65.png";